<template>
  <div id="AboutMeVideo2" style="z-index: 2;" :class="sectionClass">
    <VideoPlayer
      src="/static/about-me/v2_720p.mp4"
      cover="/static/about-me/p2.webp"
      style="scale: 0.6;"
    />

    <StickMe
      ref="target"
      name="26"
      size="168"
      left="51"
      top="49"
      style="scale: 0.6;"
    />
    <!-- <StickMe
      name="24"
      size="38"
      left="-73"
      top="8"
      style="z-index: -1;"
      uk-parallax="x: -200%, 1000%; y: -100%, 500%"
    /> -->
    <StickMe
      id="FallingSticker2Anchor"
      name="3"
      size="35"
      left="94"
      top="-1"
      uk-parallax="x: -30%"
    />
    <StickMe name="17" size="19" left="50" top="9" uk-parallax="x: -20%" />
    <StickMe name="17" size="19" left="-54" top="30" />
    <StickMe name="25" size="34" left="13" top="32" />
    <StickMe
      ref="stickerAnchor"
      name="27"
      size="34"
      left="100"
      top="47"
      style="opacity: 0;"
    />
    <div
      ref="stickerContainer"
      class="sticker"
      :style="{
        opacity: hide ? 0 : 1,
        top: '47%',
        left: '100%',
        width: '34%',
      }"
    >
      <StickMe
        ref="sticker"
        name="27"
        size="100"
        style="translate: 0%;"
        uk-parallax="target: #FallingSticker2Anchor; y: -70%, 20%;"
      />
    </div>
    <StickMe name="13" size="32" left="67" top="62.5" />
    <StickMe name="13" size="35" left="-28" top="52" uk-parallax="x: 20%" />
    <StickMe name="28" size="10" left="107" top="63" />
    <StickMe name="29" size="64" left="-6" top="72" />
    <StickMe name="28" size="10" left="-6" top="58" />
    <StickMe name="17" size="16" left="41" top="72" uk-parallax="x: -30%" />
    <StickMe name="3" size="31" left="37" top="93" uk-parallax="x: -15%" />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'
import VideoPlayer from '../VideoPlayer.vue'
import StickMe from './StickMe.vue'

export default {
  components: { VideoPlayer, StickMe },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
    emitHide() {
      let target = this.$refs.target.$el
      let targetRect = target.getBoundingClientRect()

      let startAt = 160

      if (targetRect.top < startAt) {
        this.$emit('hide', true)
      } else {
        this.$emit('hide', false)
      }
    },
    onScroll() {
      this.emitHide()

      let stickerAnchor = this.$refs.stickerAnchor.$el
      let stickerAnchorRect = stickerAnchor.getBoundingClientRect()
      let stickerContainer = this.$refs.stickerContainer

      let startAt = 300

      if (stickerAnchorRect.top > startAt) {
        stickerContainer.style.position = 'absolute'
        stickerContainer.style.top = stickerAnchor.style.top
        stickerContainer.style.left = stickerAnchor.style.left
        stickerContainer.style.translate = stickerAnchor.style.translate
      } else if (stickerAnchorRect.top < startAt) {
        stickerContainer.style.position = 'fixed'
        stickerContainer.style.top = `${startAt}px`
        stickerContainer.style.left = `${stickerAnchorRect.left}px`
        stickerContainer.style.width = `${stickerAnchorRect.width}px`
        stickerContainer.style.height = `${stickerAnchorRect.height}px`
        stickerContainer.style.translate = '0%'
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: false })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>

<style lang="scss" scoped>
.section {
  width: 36%;
  padding: 20% 0%;
}

.sectionMobile {
  width: 65%;
  padding: 42% 0%;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeVideo2.vue